<div class="d-flex flex-column position-relative">
    <mat-dialog-content>
        <div class="d-flex flex-column">
            <img
                class="mt-3"
                ngSrc="assets/img/sprintpay-horizontal-logo.svg"
                alt="SprintPay Logo"
                width="586"
                height="75"
            />
            <img ngSrc="assets/img/documents.svg" alt=" Ilustration" width="586" height="128" />
        </div>
        <div class="mt-3 mat-headline-4 text-center m-0" style="color: #032747">SprintPay Terms have changed</div>
        <div style="padding: 1rem 1rem 0 1rem; text-align: center">
            <p style="font-weight: 400; font-size: 18px">
                <strong>As of November 21, 2024, our </strong>
                <a style="color: #14bb9c; text-decoration: underline" [href]="termsOfUseURL" target="_NEW"
                    >Terms of Use</a
                >
                <strong> for SprintPay have been updated</strong> and need to be reviewed by you. By accepting, you
                acknowledge you’ve read them and agree to abide by their contents.
            </p>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions [align]="'end'">
        <button matButton="filled" color="sprintpay" (click)="acceptTerms()">
            Accept
            @if (isLoading) {
                <mat-icon class="ms-2" iconPositionEnd>
                    <mat-spinner diameter="21" />
                </mat-icon>
            }
        </button>
        <button
            matButton="outlined"
            appMatStrokedButtonBorder
            mat-dialog-close
            color="sprintpay"
            (click)="declineTerms()"
        >
            Decline
        </button>
    </mat-dialog-actions>
</div>
